var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "box-card mb5" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.queryForm.params,
                "label-width": "auto",
                size: "small",
                "label-position": "top",
              },
            },
            [
              _c(
                "div",
                { staticClass: "searchContainer" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "receivablePayable.PaymentStatus"
                                ),
                                prop: "payableStatus",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    multiple: "",
                                    placeholder: _vm.$t(
                                      "operationCenter.PleaseSelect"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.queryForm.params.payableStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "payableStatus",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryForm.params.payableStatus",
                                  },
                                },
                                _vm._l(_vm.PAYABLE_STATUS, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("GlobalSetObj.SubjectPayment"),
                                prop: "providerId",
                              },
                            },
                            [
                              _c("QueryProviderCmp", {
                                attrs: {
                                  val: _vm.queryForm.params.providerId,
                                  type: _vm.queryForm.params.payableTypes,
                                },
                                on: { change: _vm.changeProvider },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.Outlets"),
                                prop: "siteIds",
                              },
                            },
                            [
                              _c("QuerySiteCmp", {
                                attrs: {
                                  val: _vm.queryForm.params.siteIds,
                                  multiple: true,
                                  "multiple-limit": 10,
                                  "provider-id":
                                    _vm.queryForm.params.providerId,
                                  "payable-types":
                                    _vm.queryForm.params.payableTypes,
                                },
                                on: {
                                  change: function (val) {
                                    return (_vm.queryForm.params.siteIds = val)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("collectionCenter.businessT"),
                                prop: "businessType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: _vm.$t(
                                      "operationCenter.PleaseSelect"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.queryForm.params.businessType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "businessType",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.businessType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("basicData.all"),
                                      value: null,
                                    },
                                  }),
                                  _vm._l(_vm.P_BUSINESS_TYPE, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("collectionCenter.TypeBill"),
                                prop: "payableTypes",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                  },
                                  on: {
                                    change: function (val) {
                                      return (_vm.queryForm.params.providerId =
                                        "")
                                    },
                                  },
                                  model: {
                                    value: _vm.queryForm.params.payableTypes,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "payableTypes",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.payableTypes",
                                  },
                                },
                                _vm._l(_vm.PAYABLE_TYPE, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "receivablePayable.MailSendingStatus"
                                ),
                                prop: "emailSendingStatus",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: _vm.$t(
                                      "receivablePayable.PleaseSelect"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value:
                                      _vm.queryForm.params.emailSendingStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "emailSendingStatus",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryForm.params.emailSendingStatus",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("basicData.all"),
                                      value: "",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("collectionCenter.sent"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("collectionCenter.NotSent"),
                                      value: 2,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "collectionCenter.InTransit"
                                      ),
                                      value: 3,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "collectionCenter.SendFailure"
                                      ),
                                      value: 4,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("receivablePayable.BillingDate"),
                                prop: "payableTimes",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "daterange",
                                  "range-separator":
                                    _vm.$t("operationCenter.to"),
                                  "start-placeholder": _vm.$t(
                                    "operationCenter.startDate"
                                  ),
                                  "end-placeholder": _vm.$t(
                                    "operationCenter.endDate"
                                  ),
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.queryForm.params.payableTimes,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "payableTimes",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.payableTimes",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.ExistenceDocuments"),
                                prop: "haveFile",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value: _vm.queryForm.params.haveFile,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "haveFile",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.haveFile",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.all"),
                                      value: 0,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.yes"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.No"),
                                      value: 2,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "receivablePayable.areYouRequestingPayment"
                                ),
                                prop: "requestPaymentStatus",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value:
                                      _vm.queryForm.params.requestPaymentStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "requestPaymentStatus",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryForm.params.requestPaymentStatus ",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.all"),
                                      value: "",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.yes"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.No"),
                                      value: 0,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "receivablePayable.partialPaymentRequest"
                                      ),
                                      value: 2,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "receivablePayable.PaymentSlipNumber"
                                ),
                                "label-width": "120px",
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        height: "28px",
                                      },
                                      attrs: {
                                        filterable: "",
                                        placeholder: _vm.$t(
                                          "operationCenter.PleaseSelect"
                                        ),
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.typeNumber,
                                        callback: function ($$v) {
                                          _vm.typeNumber = $$v
                                        },
                                        expression: "typeNumber",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "receivablePayable.PaymentSlipNumber"
                                          ),
                                          value: 1,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "receivablePayable.BillingBatchNumber"
                                          ),
                                          value: 2,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("InputTextareaCmp", {
                                ref: "inputTextareaRef",
                                attrs: {
                                  val: _vm.searchNum,
                                  "max-length": 200,
                                },
                                on: {
                                  input: function (_, val) {
                                    return (_vm.searchNum = val)
                                  },
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", icon: "el-icon-search" },
              on: {
                click: function ($event) {
                  return _vm.searchResources()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("operationCenter.Procurar")) + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-refresh" },
              on: { click: _vm.onReset },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.reset")))]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("div", { staticClass: "feet-s mb10" }, [
            _c(
              "div",
              { staticClass: "feet-r" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permit",
                        rawName: "v-permit:remove",
                        value:
                          "btn:payableManagement:payableCollection:approved",
                        expression:
                          "'btn:payableManagement:payableCollection:approved'",
                        arg: "remove",
                      },
                    ],
                    attrs: {
                      size: "small",
                      type: "primary",
                      disabled: _vm.isPayBut,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.operationBtn(1)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("receivablePayable.Verification")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permit",
                        rawName: "v-permit:remove",
                        value:
                          "btn:payableManagement:payableCollection:SendBill",
                        expression:
                          "'btn:payableManagement:payableCollection:SendBill'",
                        arg: "remove",
                      },
                    ],
                    staticClass: "feet-btn",
                    attrs: {
                      size: "small",
                      type: "primary",
                      disabled: _vm.isSendBillBut,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onSendBill(1)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("receivablePayable.SendBill")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permit",
                        rawName: "v-permit:remove",
                        value:
                          "btn:payableManagement:payableCollection:SendBill",
                        expression:
                          "'btn:payableManagement:payableCollection:SendBill'",
                        arg: "remove",
                      },
                    ],
                    staticClass: "feet-btn",
                    attrs: {
                      type: "primary",
                      size: "small",
                      disabled: !_vm.selectData.length,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onSendBill(2)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("receivablePayable.batchSendEmail")) +
                        " "
                    ),
                  ]
                ),
                _c("CustomStatusBar", {
                  staticClass: "feet-btn",
                  attrs: {
                    "columns-data": _vm.PAYABLE_TABLE_COLUMNS,
                    params: _vm.searchParams,
                    "save-params": _vm.customParams,
                  },
                  on: { updateColumns: _vm.updateColumns },
                }),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permit",
                        rawName: "v-permit:remove",
                        value:
                          "btn:payableManagement:payableCollection:EditFile",
                        expression:
                          "'btn:payableManagement:payableCollection:EditFile'",
                        arg: "remove",
                      },
                    ],
                    staticClass: "feet-btn",
                    attrs: {
                      size: "small",
                      type: "primary",
                      disabled: _vm.isEditFile,
                    },
                    on: { click: _vm.openUpdateFile },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("GlobalSetObj.edit")) +
                        _vm._s(_vm.$t("base.document"))
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.recallIds.length === 0,
                      type: "danger",
                      size: "small",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.recallAll()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("receivablePayable.withdraw")))]
                ),
                _vm._v(" "),
                _c("BradescoCmp", {
                  attrs: { "select-data": _vm.selectData },
                  on: { updatePage: _vm.getExaminePage },
                }),
                _c("payment-santander", {
                  attrs: { "select-data": _vm.selectData },
                  on: { updatePage: _vm.getExaminePage },
                }),
                _c(
                  "el-popover",
                  { attrs: { placement: "bottom-start", trigger: "hover" } },
                  [
                    _c(
                      "div",
                      { staticClass: "feet" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "warning" },
                            on: {
                              click: function ($event) {
                                return _vm.paymentRequest(1)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("receivablePayable.markPaymentRequest")
                              )
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "feet-btn",
                            attrs: { size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.paymentRequest(0)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("receivablePayable.cancelPaymentRequest")
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permit",
                            rawName: "v-permit:remove",
                            value:
                              "btn:payableManagement:payableCollection:examine",
                            expression:
                              "'btn:payableManagement:payableCollection:examine'",
                            arg: "remove",
                          },
                        ],
                        attrs: {
                          slot: "reference",
                          type: "success",
                          size: "small",
                        },
                        slot: "reference",
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$i18n.t("receivablePayable.paymentRequest")
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "feet-r" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permit",
                        rawName: "v-permit:remove",
                        value:
                          "btn:payableManagement:payableCollection:exportBillFile",
                        expression:
                          "'btn:payableManagement:payableCollection:exportBillFile'",
                        arg: "remove",
                      },
                    ],
                    attrs: { size: "small", type: "info" },
                    on: { click: _vm.onExportBillFile },
                  },
                  [
                    _vm._v(_vm._s(_vm.$t("basicData.导出账单文件"))),
                    _c("i", { staticClass: "el-icon-download el-icon--right" }),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permit",
                        rawName: "v-permit:remove",
                        value: "btn:payableManagement:payableCollection:export",
                        expression:
                          "'btn:payableManagement:payableCollection:export'",
                        arg: "remove",
                      },
                    ],
                    staticStyle: { margin: "0" },
                    attrs: { size: "small", type: "info" },
                    on: { click: _vm.onExport },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("CenterForSorting.export")) +
                        _vm._s(
                          _vm.$t("receivablePayable.PaymentOrderInformation")
                        )
                    ),
                    _c("i", { staticClass: "el-icon-download el-icon--right" }),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c("TableStatisticiansCmp", {
            attrs: { "table-data": _vm.tableData },
          }),
          _c(
            "el-table",
            {
              key: _vm.tableKey,
              ref: "elTable",
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                height: _vm.tableHeightRow.height,
                border: "",
                "row-key": "idCopy",
                "tree-props": { children: "meetSiteBill", hasChildren: true },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "55",
                  align: "center",
                  selectable: _vm.selectable,
                },
              }),
              _vm._l(_vm.currentColumns, function (item) {
                return _c("el-table-column", {
                  key: item.prop,
                  attrs: {
                    prop: item.prop,
                    label: item.label,
                    align: item.align,
                    "min-width": item.width,
                    "show-overflow-tooltip": true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "payableNumber"
                              ? _c("span", [
                                  scope.row.isParent === true
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "batchNumber",
                                          on: {
                                            click: function ($event) {
                                              return _vm.showBillBatchNumber(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(scope.row.payableNumber)
                                          ),
                                        ]
                                      )
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.billBatchNumber)
                                        ),
                                      ]),
                                ])
                              : item.prop === "businessType"
                              ? _c("div", [
                                  scope.row.businessType === 2
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("collectionCenter.lanshou")
                                          )
                                        ),
                                      ])
                                    : scope.row.businessType === 3
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("collectionCenter.dispatch")
                                          )
                                        ),
                                      ])
                                    : scope.row.businessType === 1
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "collectionCenter.turnTransport"
                                            )
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : item.prop === "billFee"
                              ? _c("div", [
                                  scope.row.isParent === true
                                    ? _c("span", [
                                        _vm._v(_vm._s(scope.row.billFee)),
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.totalReceivable)
                                        ),
                                      ]),
                                ])
                              : item.prop === "createTime"
                              ? _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.createTime
                                          ? scope.row.createTime.replace(
                                              "T",
                                              " "
                                            )
                                          : ""
                                      )
                                    ),
                                  ]),
                                ])
                              : item.prop === "auditTime"
                              ? _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.auditTime
                                          ? scope.row.auditTime.replace(
                                              "T",
                                              " "
                                            )
                                          : ""
                                      )
                                    ),
                                  ]),
                                ])
                              : item.prop === "remark"
                              ? _c("div", [
                                  _c("div", {
                                    staticClass: "remarkStyle",
                                    domProps: {
                                      innerHTML: _vm._s(scope.row.remark),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showImg($event)
                                      },
                                    },
                                  }),
                                ])
                              : item.prop === "requestPaymentStatus"
                              ? _c(
                                  "div",
                                  [
                                    scope.row.requestPaymentStatus === 1
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "success" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("GlobalSetObj.yes"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    scope.row.requestPaymentStatus === 0
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "danger" } },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("GlobalSetObj.No"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    scope.row.requestPaymentStatus === 2
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "warning" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "receivablePayable.partialPaymentRequest"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : item.prop === "emailSendingStatus"
                              ? _c(
                                  "div",
                                  [
                                    scope.row.emailSendingStatus === 1
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "success" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("collectionCenter.sent")
                                              )
                                            ),
                                          ]
                                        )
                                      : scope.row.emailSendingStatus === 2
                                      ? _c("el-tag", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("collectionCenter.NotSent")
                                            )
                                          ),
                                        ])
                                      : scope.row.emailSendingStatus === 3
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "info" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "collectionCenter.InTransit"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : scope.row.emailSendingStatus === 4
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "danger" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "collectionCenter.SendFailure"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : item.prop === "emailSenderFileUrl"
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "flex-wrap": "wrap",
                                    },
                                  },
                                  _vm._l(scope.row.allFileList, function (key) {
                                    return _c(
                                      "el-link",
                                      {
                                        key: key.fileUrl,
                                        staticStyle: { "margin-right": "10px" },
                                        attrs: {
                                          type: "success",
                                          href: key.fileUrl,
                                          target: "_blank",
                                        },
                                      },
                                      [_vm._v(_vm._s(key.fileName))]
                                    )
                                  }),
                                  1
                                )
                              : _c("div", [
                                  _vm._v(_vm._s(scope.row[item.prop])),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.operate"),
                  align: "center",
                  width: "140",
                  fixed: "right",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.payableStatus === 0
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "permit",
                                        rawName: "v-permit:remove",
                                        value:
                                          "btn:payableManagement:payableCollection:recall",
                                        expression:
                                          "'btn:payableManagement:payableCollection:recall'",
                                        arg: "remove",
                                      },
                                    ],
                                    attrs: { type: "danger", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.recall(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("receivablePayable.withdraw")
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.queryForm.pageNumber,
                  "page-sizes": [10, 20, 50, 100, 500],
                  "page-size": _vm.queryForm.pageSize,
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getExamineCurrentPage,
                  "size-change": _vm.getExamineSizePage,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title:
              _vm.$t("receivablePayable.ReconcileBatchDetails") +
              "-" +
              _vm.batchNumber,
            "append-to-body": true,
            visible: _vm.showDetail,
            direction: "ltr",
            "custom-class": "drawerClass",
            label: _vm.$t("receivablePayable.ReconcileBatchDetails"),
            size: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDetail = $event
            },
          },
        },
        [
          _c("batch-number-detail", {
            key: _vm.batchNumber,
            attrs: {
              "batch-number": _vm.batchNumber,
              "bill-batch-data": _vm.billBatchData,
            },
            on: { closeDetail: _vm.closeDetail },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("receivablePayable.Verification"),
            visible: _vm.showCollection,
            "custom-class": "dialogClass",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCollection = $event
            },
          },
        },
        [
          _c("collection-detail", {
            key: _vm.collectionKey,
            attrs: {
              "recharge-data": _vm.selectData[0],
              "account-option": _vm.accountOption,
            },
            on: { collectionUpdate: _vm.collectionUpdate },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "imgs" },
        [
          _vm.imageViewerObj.showViewer
            ? _c("el-image-viewer", {
                attrs: {
                  "on-close": _vm.closeViewer,
                  "url-list": _vm.imageViewerObj.imgArr,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("receivablePayable.SendEmailConfirmation"),
            visible: _vm.sendBillRow.isShow,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.sendBillRow, "isShow", $event)
            },
          },
        },
        [
          _vm.sendBillRow.isShow
            ? _c("EnvieUmEmailCmp", {
                attrs: { row: _vm.sendBillRow.row },
                on: { close: _vm.onEnvUmEmailClose },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("UpdateFileCmp", {
        ref: "updateFileRef",
        on: { update: _vm.getExaminePage },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }